const Req = window.Req;
Req.localPath = Req.localPath || '/skin/untitled/pub/';

import cfg from './config.json';

Req(
	'mobilefix', // <-- fixes rotation zoom bug in Mobile Safari, and scrolls page down to hide url bar...

	'eutils',
	'ga',

	'onformatchange',
	'mobilemenu',
	'treecollapse',
	'query',
	'autovalidate',
	'anchortags',

	function() {
		'use strict';

		const $ = window.jQuery;

		const $html = $( 'html' );

		const $win =  $( window );
		// const $body = $( 'body' );
		const $doc = $(document);

		const formatMonitor = $.formatChange(
			window.FormatChange.makeGroups(cfg.mediaFormats)
		);
		const media = formatMonitor.media;

		const i18n = { en: {} };
		i18n.is = $.beget(i18n.en);
		const txt = i18n[$('html').attr('lang')] || i18n.en;

		// =========================================================================================================================
		//   Default Configs
		// =========================================================================================================================

		// =========================================================================================================================
		//   Actions
		// =========================================================================================================================

		const loggedIn = window.EPLICA_loggedin;
		const noop = $.noop;

			const setBackground = (elm, url) => {
				elm.css({ 'background-image': 'url(' + url + ')' });
			};

		const _preLoadImage = ($image) => {
			$image.each(function() {
				const $this = $(this);
				$win
					.on('formatchange', function() {
						if (media.becameSmall) {
							setBackground($this, $this.attr('data-imgsmall'));
						} else if (media.isLarge) {
							setBackground($this, $this.attr('data-imglarge'));
						}
					})
					.trigger('formatchange');
			});

			const imageTemp = document.createElement('img');
			imageTemp.src = $image.attr('data-imglarge');
			imageTemp.onload = function() {
				$image.addClass('loaded');
			};
		};

		const imgBanner = () => {
			if ($html.is('.home')) {
				_preLoadImage($('.imgbanner ins.image'));
			}
		};

		// const imgBanner = () => {
		// 		console.log('imgbanner')
		// 		var $image = $('.imgbanner ins.image');
		// 		if ($image.length) {
		// 			$win.on('formatchange', function (/*e*/) {
		// 					if ( media.format === 'netbook' || media.format === 'wide' ) {
		// 						$image.each(function () {
		// 								$(this).css({ 'background-image': 'url('+$(this).attr('data-imglarge')+')' });
		// 							});
		// 					} else if ( media.format === 'tablet' ) {
		// 						$image.each(function () {
		// 								$(this).css({ 'background-image': 'url('+$(this).attr('data-imglarge')+')' });
		// 							});
		// 					} else if ( media.format === 'phone' || media.format === 'phablet' ) {
		// 						$image.each(function () {
		// 								$(this).css({ 'background-image': 'url('+$(this).attr('data-imgsmall')+')' });
		// 							});
		// 					}
		// 				});
		// 		};
		// 	}
		// };

		imgBanner();

		const tagFileAndExternalLinks = function(root) {
			i18n.en.newWindow = 'Opens in new window';
			i18n.is.newWindow = 'Opnast í nýjum vafraglugga';
			i18n.en.fileText = 'file';
			i18n.is.fileText = 'skjal';

			root.query('a:not(.videolink)').anchorTags({
				usePatterns: ['doc', 'pdf', 'xls'],
				// localDomains: ['\\.*.eplica.is','\\.*.domain.is'],
				onTag: function(link, is) {
					const text = is.pattern
						? is.pattern[0].toUpperCase() + ' ' + txt.fileText
						: is.external
						? txt.newWindow
						: '';
					text &&
						link
							.attr('target', '_blank')
							.attr(
								'title',
								$.trim(link.attr('title') || link.text()) + ' (' + text + ')'
							);

					if (link.find('img').length) {
						link.addClass('has-image');
					}

					const gaCat = is.external
						? 'external'
						: is.tel
						? 'telephone'
						: is.mailto
						? 'email'
						: is.pattern
						? 'download'
						: '';
					if (window.ga && gaCat) {
						link.on('click', function(/*e*/) {
							window.gaHXM.eventPing(
								gaCat,
								is.pattern ? 'click-' + is.pattern[0] : 'click',
								link.attr('href').replace(/^(tel|mailto):/i, ''),
								1,
								is.external ? true : false
							);
						});
					}
				},
			});
		};

		const _enhanceVideolinks = function(article) {
			article.find('a.videolink').Req('q-videolinks', function() {
				$(this).videoLinks();
			});
		};

		const _enhanceAudiolinks = !('src' in $('<audio/>')[0])
			? noop
			: function(article) {
					article.find('a.audioplayer').each(function(i, link) {
						$('<audio/>')
							.prop({
								src: link.href,
								preload: 'none',
								controls: true,
							})
							.insertBefore(link)
							.append(link);
					});
			  };

		const prepArticleContent = function(root) {
			root.query('.article').each(function() {
				const article = $(this);
				_enhanceVideolinks(article);
				_enhanceAudiolinks(article);
			});
		};

		const initForms = function(root) {
			root.query('form').autoValidate({
				errorMsgType: 'inlineonly',
				validateEachField: 'change',
			});
		};

		const handleTelephoneLinks = function() {
			// depends on formatChange()
			i18n.is.callPrompt = 'Hringja í ';
			i18n.en.callPrompt = 'Call ';
			$doc.on('click', 'a[href^="tel:"]', function(e) {
				if (media.isLarge) {
					const m = $(this)
							.text()
							.match(/\+?\d[\s\-\d]+\d/),
						num = (m && m[0]) || this.href.substr(4);
					if (!confirm(txt.callPrompt + num + ' ?')) {
						e.preventDefault();
					}
				}
			});
		};


    // .mnav treecollapse
    var collapseMobileMenu = function () {
			console.log('collapse')
			$doc.one('mobilemenuopened', function (/*e*/) {
					$('.mnav').treeCollapse({
							branch: 'li:has(ul)',
							doTogglers: 1,
							toggler: '> a.expand',
							startOpen: 'li.parent:has(ul), li.current:has(ul)',
						});
				});
		};

		collapseMobileMenu();

		// =========================================================================================================================
		//   Run Init Actions
		// =========================================================================================================================

		$doc
			.on('domupdated.main', function(e, updatedFragment) {
				const root = $(updatedFragment || this);

				// Scripts sem hafa áhrif á article content eiga ekki að keyra þegar notendur eru loggedIn vegna ritilsins.
				!loggedIn && root.query('table').wrap('<div class="tablewrap" />');
				!loggedIn &&
					root.query('ol').attr('data-oltype', function() {
						return this.type || '';
					}); // enable fancy styling on <ol> markers....

				!loggedIn && tagFileAndExternalLinks(root); // Þarf að keyrast soldið seint vegna ga tracking

				prepArticleContent(root);

				initForms(root);
			})
			.trigger('domupdated.main');


			$.initMobileMenu({
				mediaGroup: 'HeaderSmall',
				stickyHeader: false,
				resetScroll: false,
			});

		$.initStickyHeader({
			minimal: true,
			headerHeight: () =>
				parseInt(
					window
						.getComputedStyle(document.documentElement)
						.getPropertyValue('padding-top')
				),
		}).start();
		handleTelephoneLinks(); // <- depends on formatChange

		$('html').removeClass('beforejsinit'); //remove flicker trick

		$.fixSkiplinks && $.fixSkiplinks();

		// // Loading body class scripts
		// const theme_revision = window.Req.joinUrl.split('%7C').slice(1).pop();
		// const debugSrc = document.location.search.indexOf('jsdebug') > 0 ? '-source' : '';
		// Req.loadPageScripts({ folder:'', ext: debugSrc+'.js?'+theme_revision, rootElm: document.documentElement });
	}
);
